import { render, staticRenderFns } from "./HeaderControlsAddProject.vue?vue&type=template&id=5021c431&scoped=true&"
import script from "./HeaderControlsAddProject.vue?vue&type=script&lang=js&"
export * from "./HeaderControlsAddProject.vue?vue&type=script&lang=js&"
import style0 from "./HeaderControlsAddProject.vue?vue&type=style&index=0&id=5021c431&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5021c431",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5021c431')) {
      api.createRecord('5021c431', component.options)
    } else {
      api.reload('5021c431', component.options)
    }
    module.hot.accept("./HeaderControlsAddProject.vue?vue&type=template&id=5021c431&scoped=true&", function () {
      api.rerender('5021c431', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/HeaderControlsAddProject.vue"
export default component.exports